import { render } from "./JoinMemberComponent.vue?vue&type=template&id=e31c2c38&scoped=true"
import script from "./JoinMemberComponent.vue?vue&type=script&lang=js"
export * from "./JoinMemberComponent.vue?vue&type=script&lang=js"

import "./JoinMemberComponent.vue?vue&type=style&index=0&id=e31c2c38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e31c2c38"]])

export default __exports__